import md5 from 'md5'

const requestsCache = new Map()

export const getEtagHeaderName = httpMethod =>
  /^(PUT|PATCH|DELETE)$/.test(httpMethod) ? 'If-Match' : 'If-None-Match'

export const getOptionsForHash = (options = {}) => {
  const optionsForHash = { ...options }
  delete optionsForHash.method
  return optionsForHash
}

export const getRequestHash = options => {
  const optionsForHash = getOptionsForHash(options)
  return md5(JSON.stringify(optionsForHash))
}

export const etagResponseHandler = requestHash => httpResponse => {
  /* Get response from cache */
  if (httpResponse.status === 304) {
    if (!requestsCache.has(requestHash)) {
      const error = new Error('No cached data available for this 304 status response')
      error.response = httpResponse
      throw error
    }

    return requestsCache.get(requestHash).response
  }

  /* Save response to cache */
  const etagHeader = httpResponse.headers.get('etag')
  if (etagHeader) {
    requestsCache.set(requestHash, {
      etag: etagHeader,
      response: httpResponse.response,
    })
  }
  return httpResponse
}

export default requestsCache
